import { Box, Typography } from "@mui/material"
import { AnimatedBackground } from "components/ui/customComponents/animatedBackground"

export const SolicitudStatus = ({image , text}:any) => {
  return (
    <Box
    sx={{
      minHeight: "60vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    <img src={image} alt="not-found" />
    <Typography
      variant="h2"
      sx={{ fontWeight: "600", fontSize: "60px", marginY: "20px" }}
    >
      404
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: "500", fontSize: "18px" }}>
      {text}
    </Typography>
    <AnimatedBackground />
  </Box>
  )
}
